<template>
  <div class="main">
    <span class="main-config">
      <div v-if="!readOnly" class="ml-2 mr-2 mb-2 mt-2">
        <label>{{ $t('operacoes') }} </label>
        <b-form-select
          id="operation-selected"
          class="input-pentagro"
          v-model="operationSelected"
          :options="operations"
        ></b-form-select>
      </div>
      <div v-if="operationSelected" class="b-layout">
        <b-card class="name-equip" v-if="equipments.length > 0">
          <div v-for="(prop, index) in equipments" :key="prop.caption + index">
            <b-form-checkbox
              class="switch-item"
              v-model="prop.value"
              @change="ChangeOnOff($event, prop)"
              switch
              >
              {{ prop.equipName }}
            </b-form-checkbox>
          </div>
        </b-card>
        <b-card v-else>
          <label>{{ $t('operacao-sem-equipamentos') }}</label>
        </b-card>
        <div class="ml-3">
          <b-card class="equip-info">
            <div class="attr">
              <div class="inp">
                <label>{{ $t('area-m') }}</label>
                <label>{{ area ? (area.value | ParseNumber) : "0,00" }}</label>
              </div>
              <div v-if="TaxaOcupacao" class="inp">
              <label>{{ $t('ocupacao-0') }}</label>
                <label>{{ TaxaOcupacao.value | ParseNumber}}</label>
              </div>
              <div v-if="showOutletTemperature" class="inp">
                <label>{{ $t('temp-da-saida-c') }}</label>
                <b-input class="input-pentagro" v-model="TSaida.value" />
              </div>
            </div>
            <div v-if="showOptionTSaida" class="inp">
              <b-form-checkbox
              v-if="operationSelected && !readOnly"
              class="check"
              v-model.lazy="showOutletTemperature"
              >
              {{ $t('manipular-temperatura-de-saida') }}
            </b-form-checkbox>
          </div>
        </b-card>
      </div>
    </div>
  </span>
  <div v-if="jokerEquipmentList.length" class="joker">
    <label class="mt-2">{{ $t('equipamentos-coringas') }}</label>
      <div v-for="(joker, i) in jokerEquipmentList" :key="i">
        <div>
          <div class="ml-2 mr-2">
            <span v-if="readOnly">
              <label>{{ joker.caption }}</label>
            </span>
            <span v-else>
              <TextToInput
                :text="joker.caption"
                @sendText="updateCaption($event, joker)"
              >
              </TextToInput>
            </span>
          </div>
          <span class="b-layout">
            <b-card v-if="equipments.length > 0">
              <div v-for="(prop, index) in joker.equipments" :key="prop.caption + index" >
                <b-form-checkbox
                  class="switch-item"
                  v-model="prop.value"
                  @change="ChangeOnOffJoker($event, prop, equipments, joker)"
                  switch
                  >
                  {{ prop.equipName }}
                </b-form-checkbox>
              </div>
            </b-card>
            <div class="ml-3" v-if="equipments.length > 0">
              <b-card>
                <div class="inp">
                  <label>{{ $t('area-m-0') }}</label>
                  <label>{{ joker.capacidade.value | ParseNumber }}</label>
                </div>
                <div class="inp">
                  <label>{{ $t('ocupacao-0') }}</label>
                  <label>{{ joker.Ocupacao.value | ParseNumber }}</label>
                </div>
              </b-card>
            </div>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SingletonEnginnering } from "../_service/singletonEngineering";
import { NumberFormat, ParseToNumber } from "../../utils/tools";
import { JokerEquipmentMixin } from "../../../mixins/jokerEquipmentsMixin";
import TextToInput from "../../../template/TextToInput.vue";
import { FiltersMixin } from "../../../mixins/filtersMixin";


export default {
  props: {
    node: {
      type: Object,
      default: null,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },

  components: { TextToInput },

  mixins: [JokerEquipmentMixin, FiltersMixin],

  data() {
    return {
      attrList: ["area", "TaxaOcupacao", "Enabled", "TSaida"],
      area: {},
      Enabled: {},
      TaxaOcupacao: {},
      TSaida: {},
      operations: [{ value: null, text: "Selecione uma Operação" }],
      operationSelected: null,
      operationAttributeList: [],
      firstLoad: false,
      equipments: [],
      equipCap: [],
      showOutletTemperature: false,
      showOptionTSaida: false
    };
  },

  watch: {
    operationSelected() {
      if (this.firstLoad) {
        this.firstLoad = false;
        return;
      }

      this.showOutletTemperature = false;

      this.loadEquipments();

      this.operationAttributeList =
        SingletonEnginnering.getOperationsProperties(
          this.operationSelected
        ).filter((operation) => this.attrList.includes(operation.key));

      if (this.equipments.length > 0) {
        this.area = this.operationAttributeList.find(
          (p) => this.attrList[0] == p.caption
        );
      }

      this.TaxaOcupacao = this.operationAttributeList.find(
        (p) => this.attrList[1] == p.caption
      );

      this.Enabled = this.operationAttributeList.find(
        (p) => this.attrList[2] == p.key
      );

      this.TSaida = this.operationAttributeList.find(
        (p) => this.attrList[3] == p.caption
      );

      this.showOptionTSaida = !!this.TSaida;

      if (this.area)
        this.area.value =
          this.equipments.length > 0 ? ParseToNumber(this.area.value) : "";
      if (this.TaxaOcupacao)
        this.TaxaOcupacao.value = isNaN(parseFloat(this.TaxaOcupacao.value))
          ? ""
          : ParseToNumber(this.TaxaOcupacao.value);
      if (this.TSaida)
        this.TSaida.value = isNaN(parseFloat(this.TSaida.value))
          ? ""
          : ParseToNumber(this.TSaida.value);

      this.jokerEquipmentList = [];
      this.updateNode();
    },

    "area.value"() {
      this.updateNode();
    },

    "TaxaOcupacao.value"() {
      this.updateNode();
    },

    "TSaida.value"() {
      this.updateNode();
    },

    showOutletTemperature() {
      this.populateTSaida();
    },
  },

  methods: {
    loadNode() {
      if (this.node.data.length > 0) {
        if (this.node.data[0].index) {
          this.firstLoad = true;
          this.operationSelected = this.node.data[0].index;
          this.buildJokerEquipment(
            this.node.data[0].index,
            this.node.jokerCaption
          );
          this.loadNotInput();
          this.loadOperationProperties();
        }
      }

      this.equipments = new Array();
      
      this.showOutletTemperature = this.node.showOutletTemperature;
      
      this.node.data.forEach((p) => {
        if (p.equipName) {
          let equip = p.clone();
          equip.value = parseInt(equip.value) ? true : false;
          
          this.equipments.push(equip);
        }
        
        if (p.key == "Enabled") {
          this.Enabled = p;
        }
        
        if (p.key == "TSaida") {
          p.value = ParseToNumber(p.value);
          this.TSaida = p;
        }
      });
      
      if (this.TSaida.value) {
        this.showOptionTSaida = true;
      }
      this.loadEquipments();
    },

    populateTSaida() {
      if (this.TSaida && !this.TSaida.value) {
        this.TSaida = this.operationAttributeList.find(
          (p) => "TSaida" == p.caption
        );

        this.TSaida.value = isNaN(parseFloat(this.TSaida.value))
          ? ""
          : ParseToNumber(this.TSaida.value);
      }
      this.updateNode();
    },

    loadNotInput() {
      this.operationAttributeList =
        SingletonEnginnering.getOperationsProperties(
          this.operationSelected
        ).filter((operation) => this.attrList.includes(operation.key));
      let attrNotInput = ["area", "TaxaOcupacao"];

      attrNotInput.forEach((attrName) => {
        this[attrName] = this.operationAttributeList.find(
          (p) => attrName == p.caption
        );

        if (attrName == "area" && this.area)
          this.area.value =
            this.equipments.length > 0 ? ParseToNumber(this.area.value) : "";
        if (attrName == "TaxaOcupacao" && this.TaxaOcupacao)
          this.TaxaOcupacao.value = isNaN(parseFloat(this.TaxaOcupacao.value))
            ? ""
            : ParseToNumber(this.TaxaOcupacao.value);
      });
    },

    updateCaption(caption, joker) {
      joker.caption = caption;
      this.updateNode();
    },

    updateNode() {
      if(!this.area || !this.Enabled)
        return

      let attrs = [];
      
      if(this.Enabled)
        attrs.push(this.Enabled.clone())

      if(this.area && this.area.key)
        attrs.push(this.area.clone())

      this.equipments.forEach((e) => {
        let prop = e.clone();
        prop.value = e.value ? "1,00" : "0,00";
        attrs.push(prop);
      });

      this.node.showOutletTemperature = this.showOutletTemperature;

      if (this.showOutletTemperature) {
        let prop = this.TSaida.clone();
        prop.value = NumberFormat(this.TSaida.value);
        attrs.push(prop);
      }

      this.node.attrs = attrs;
      this.updateJokerNode(this.node, this.jokerEquipmentList);
    },

    loadOperationProperties(){
      let equipmentProps = SingletonEnginnering.getOperationsProperties(this.operationSelected)
      this.attrList.forEach(attr => {
        let prop = equipmentProps.find(p => p.key == attr)
        if(prop)
          this[attr] = prop
      })
    },

    loadEquipments() {
      let equipsName = SingletonEnginnering.getOperationsEquipments(
        this.operationSelected
      );

      let propsByEquipment = SingletonEnginnering.getEquipamentsProperties(
        this.operationSelected
      );
      let auxEquipment = new Array();

      equipsName.forEach((e) => {
        let props = propsByEquipment[e];
        Object.keys(props).forEach((p) => {
          if (props[p].caption == "Status") {
            props[p].value = parseInt(props[p].value) ? true : false;
            auxEquipment.push(props[p]);
          }
          if (props[p].caption == "Capacidade") {
            if (props[p].strValue != "") {
              props[p].value = props[p].strValue;
            }
            this.equipCap.push(props[p]);
          }
        });
      });
      this.equipments = auxEquipment;
    },

    ChangeOnOff(event, prop) {
      prop.value = event;
      this.ChangeCapacidade();
      this.switchStatusJoker(
        prop,
        this.equipments,
        false,
        this.ChangeCapacidade
      );
      this.updateNode();
    },

    ChangeCapacidade() {
      if (this.area) {
        this.area.value = 0;
        this.equipments.forEach((e) => {
          let cap = this.equipCap.find((c) => c.equipName == e.equipName);
          if (e.value && cap)
            this.area.value += parseFloat(String(cap.value).replace(",", "."));
        });

        if (this.area.value == 0) {
          this.Enabled.value = "false";
        } else {
          this.Enabled.value = "true";
        }
      }
    },

    loadOperation() {
      let opList = SingletonEnginnering.operations.filter((o) => o.match(/EH/));
      this.operations.splice(1);
      opList.forEach((op) => this.operations.push({ value: op, text: op }));
    },
  },

  mounted() {
    this.loadOperation();
    this.loadNode();
    this.ChangeCapacidade();
    this.changeExternalCapacity = function () {
      this.ChangeCapacidade();
    };
    this.updataNodeInMixin = function () {
      this.updateNode();
    };
  },
};
</script>

<style scoped>
.main {
  display: flex;
}

.main-config,
.joker {
  width: 500px;
  height: 350px;
  overflow-y: auto;
}

.name-equip{
  min-width: 220px;
}

.width-155 {
  width: 200px;
}

.equip-info {
  width: 220px;
  height: 220px;
}

.attr {
  height: 140px;
}

.input-data {
  width: 70px;
  text-align: right;
}

form {
  padding: 10px;
  color: #0009;
}

.form-control {
  width: 30%;
  height: 30px;
  text-align: right;
}

.check {
  margin: 2%;
}

.b-layout {
  display: flex;
  justify-content: space-between;
}

input {
  margin-left: 5px;
}

.inp {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.inp > label {
  height: 25px;
}
</style>